import { render, staticRenderFns } from "./KeuringenQueue.vue?vue&type=template&id=78554d8e"
import script from "./KeuringenQueue.vue?vue&type=script&lang=js"
export * from "./KeuringenQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports